import { useSessionStore } from "@/domains/-session/stores/useSessionStore";
import { dateFromServer } from "@/functions/dates";
import sdk, { MessageFromAPI, PostMessage, Response } from "@/sdk";
import { nextTick, reactive } from "vue";

export interface Message {
  message: string;
  message_datetime: Date;
  source: "agent" | "user" | "system"
}

export class ChatbotManager{

    private _isWaiting: boolean;
    private _errorKey: string;
    private _messages: Message[];
    private _scrollCallback?: Function;

    constructor(){
        this._isWaiting = false
        this._errorKey = 'global'
        this._messages = []

        
    }

    public async sendToChatbot(message: string, beforeSendCallback?: Function): Response<PostMessage.Result>{
        this._messages.push({
            message: message,
            source: 'user',
            message_datetime: new Date(),
        })
        this._isWaiting = true
        nextTick(() => {
            if(beforeSendCallback) beforeSendCallback()
            this.forceScrollDown()
        })
        try{
            const chatbotMessage = await sdk.postMessage({message})
            /* .catch(err => {
                console.log(err)
                if(err.status && err.status === 403){
                    useSessionStore().signOut()
                }
            }) */
            this._isWaiting = false
            this._messages.push({
                message: chatbotMessage.data.message,
                source: chatbotMessage.data.source,
                message_datetime: dateFromServer(chatbotMessage.data.message_datetime)
            })
            return chatbotMessage
        }
        catch(err){
            if(err.status && err.status === 403){
                useSessionStore().signOut()
            }
            throw 'Cannot handle posting message'
        }
    }

    public addFakeChatbotMessage(message: string){
        this._messages.push({
            message: message,
            source: 'agent',
            message_datetime: new Date()
        })
    }

    public async getHistory(){
        const historyMessages = await sdk.getMessages()

        for(const message of historyMessages.data){
            this._messages.push({
                message: message.message,
                source: message.source,
                message_datetime: dateFromServer(message.message_datetime)
            })
        }
                
    }

    public setScrollCallback(callback: Function){
        this._scrollCallback = callback
    }

    public forceScrollDown(){
        if(this._scrollCallback)
            this._scrollCallback()
    }

    public get isWaiting(){
        return this._isWaiting
    }

    public get errorKey(){
        return this._errorKey
    }

    public get messages(){
        return this._messages
    }

    public get hasHistory(){
        return this._messages.length > 0
    }

    private formatMessage(str:string):string{
        let text:string = str

        text = text.replace(/'/gim, '&#x27;')

        return text
    }

}

let chatbotManager: ChatbotManager;

export function useChatbot(): ChatbotManager {
  if (!chatbotManager)
    chatbotManager = reactive(new ChatbotManager()) as ChatbotManager;

  return chatbotManager;
}